import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { apiClient } from "@/services";

const AdminDashboardTestPage: React.FC = () => {
  const [testResult, setTestResult] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  const testEndpoints = async () => {
    setIsLoading(true);
    setTestResult("Testing endpoints...\n");

    try {
      // Test 1: KPIs endpoint
      setTestResult(prev => prev + "Testing /api/admin/dashboard/kpis...\n");
      const kpisResponse = await apiClient.get('/api/admin/dashboard/kpis');
      setTestResult(prev => prev + `✅ KPIs: Status ${kpisResponse.status}\n`);
      setTestResult(prev => prev + `   Data: ${JSON.stringify(kpisResponse.data, null, 2)}\n\n`);
    } catch (error: any) {
      setTestResult(prev => prev + `❌ KPIs Error: ${error.message}\n`);
      if (error.response) {
        setTestResult(prev => prev + `   Status: ${error.response.status}\n`);
        setTestResult(prev => prev + `   Data: ${JSON.stringify(error.response.data, null, 2)}\n\n`);
      }
    }

    try {
      // Test 2: Transactions endpoint
      setTestResult(prev => prev + "Testing /api/admin/reportes/transacciones...\n");
      const transactionsResponse = await apiClient.get('/api/admin/reportes/transacciones');
      setTestResult(prev => prev + `✅ Transactions: Status ${transactionsResponse.status}\n`);
      setTestResult(prev => prev + `   Data keys: ${Object.keys(transactionsResponse.data)}\n\n`);
    } catch (error: any) {
      setTestResult(prev => prev + `❌ Transactions Error: ${error.message}\n`);
      if (error.response) {
        setTestResult(prev => prev + `   Status: ${error.response.status}\n`);
        setTestResult(prev => prev + `   Data: ${JSON.stringify(error.response.data, null, 2)}\n\n`);
      }
    }

    setIsLoading(false);
  };

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold">Admin Dashboard Endpoint Test</h1>
      
      <Button onClick={testEndpoints} disabled={isLoading}>
        {isLoading ? "Testing..." : "Test Endpoints"}
      </Button>

      <Card>
        <CardHeader>
          <CardTitle>Test Results</CardTitle>
        </CardHeader>
        <CardContent>
          <pre className="bg-muted p-4 rounded text-sm overflow-auto max-h-96">
            {testResult || "Click 'Test Endpoints' to run tests"}
          </pre>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminDashboardTestPage;
